import React from 'react';
import { Switch, useRouteMatch, useLocation } from 'react-router-dom';

import qs from 'qs';

import Flows from 'src/components/Flows/Flows';

import FlowEditor from 'src/components/Flows/Flow';
import Page from 'src/components/base/Page';

import * as Editor from 'src/components/Flowsteps/flowsteps';


function FlowEditorRoute({ path, component, title, backTo, ...props }) {
  const match = useRouteMatch(path);
  if (!match) { return null }

  const { id } = match.params;
  return (
    <Page key={id} path={path} title={title} component={component} backTo={backTo} id={id} {...props} />
  )
}

function FlowRoute({ path, ...otherProps }) {
  const match = useRouteMatch(path);
  if (!match) { return null }

  return (
    <Flows {...otherProps} />
  );
}


export default ({ match }) => (
  <Switch>
    <FlowEditorRoute path={`${match.url}/flow/:id?`} component={FlowEditor} title={'Flow'} backTo={match.url} />
    <FlowRoute path={`${match.url}`} />
  </Switch>
);
